import React from 'react'

const Footer = () => {
    return (
        <div>
            <hr></hr>
            <p className="footer-text">Made with ❤ by Saraswati<br></br>
            <br></br>
            <br></br>
            </p>
        </div>
    )
}

export default Footer
